<script setup>
import { ref } from "vue";
import ExploremoreLcCat from "./exploremore-lc-cat.vue";
import "@/styles/css/learning-center.scss";
const view = ref(false);
const openView = () => {
  view.value = true;
};
</script>
<template>
  <div
    class="container-learning-center page-container"
    style="margin-top: 70px"
  >
    <section class="lc_completeToc">
      <section class="learning-center_banner">
        <div class="visible-lg visible-md visible-sm">
          <picture>
            <source
              srcset="
                https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-demat-account.webp
              "
              type="image/webp"
            />
            <img
              title="Demat Account Articles"
              alt="demat account"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-demat-account.png"
            />
          </picture>
        </div>
        <div class="visible-xs">
          <picture>
            <source
              srcset="
                https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-demat-account-mobile.webp
              "
              type="image/webp"
            />
            <img
              alt="demat account"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-demat-account-mobile.png"
            />
          </picture>
        </div>
      </section>

      <section class="toc_container LC-article">
        <div class="container-fluid ht-page faq">
          <div class="">
            <div class="lc-cat-toc-wraper">
              <h1 class="curr-tax">Demat Account Articles</h1>
              <br />
              <p class="curr-tax-desc">
                Build your understanding about demat accounts with an extensive
                guide.
              </p>
            </div>
            <div class="lc-cat-toc-wraper">
              <p class="toc-txt">TABLE OF CONTENTS</p>
              <ul class="lc-category-page-wrapper hidden-md hidden-lg">
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="1"
                      href="/learning-center/demat-account/best-demat-account-for-beginners-in-india/"
                      >Best Demat Account in India for Beginners</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="2"
                      href="/learning-center/demat-account/how-to-download-demat-holdings-statement/"
                      >How to Download Demat Holdings Statement</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="3"
                      href="/learning-center/demat-account/what-is-a-brokerage-account/"
                      >What Is a Brokerage Account?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="4"
                      href="/learning-center/demat-account/demat-account-opening-procedure/"
                      >Demat Account Opening Procedure &amp; Steps for
                      Beginners</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="5"
                      href="/learning-center/demat-account/what-is-the-minimum-amount-required-for-opening-a-demat-account/"
                      >What Is The Minimum Amount Required For Opening A Demat
                      Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="6"
                      href="/learning-center/demat-account/can-a-demat-account-be-opened-without-a-pan-card/"
                      >Can a Demat Account Be Opened Without a PAN Card?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="7"
                      href="/learning-center/demat-account/how-to-buy-sell-shares-in-demat-account/"
                      >How to Buy &amp; Sell Shares in Demat Account?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="8"
                      href="/learning-center/demat-account/what-is-ledger-balance-in-demat-account/"
                      >What Is Ledger Balance In Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="9"
                      href="/learning-center/demat-account/is-demat-account-safe/"
                      >Is Demat Account Safe?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="10"
                      href="/learning-center/demat-account/when-bonus-shares-are-credited-in-demat-account/"
                      >When Bonus Shares Are Credited In Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="11"
                      href="/learning-center/demat-account/how-do-i-add-a-nominee-to-my-demat-account/"
                      >How Do I Add A Nominee To My Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="12"
                      href="/learning-center/demat-account/how-to-convert-physical-shares-to-demat/"
                      >How to Convert Physical Shares to Demat</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="13"
                      href="/learning-center/demat-account/how-to-use-a-demat-account-online-in-india/"
                      >How To Use A Demat Account Online In India</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="14"
                      href="/learning-center/demat-account/how-to-close-a-demat-account/"
                      >How to Close Your Demat Account Online</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="15"
                      href="/learning-center/demat-account/how-to-open-a-demat-account/"
                      >How to Open a Demat Account ?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="16"
                      href="/learning-center/demat-account/what-is-a-special-memorandum-account-sma/"
                      >What Is a Special Memorandum Account (SMA)?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="17"
                      href="/learning-center/demat-account/how-to-check-demat-account-balance/"
                      >How to Check Demat Account Balance</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="18"
                      href="/learning-center/demat-account/benefits-and-features-of-a-demat-account-understanding-the-advantages/"
                      >Benefits And Features of a Demat Account - Understanding
                      the Advantages</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="19"
                      href="/learning-center/demat-account/understanding-a-demat-account-statement/"
                      >Demat Account Holding Statement &amp; How to Get Demat
                      Statement</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="20"
                      href="/learning-center/demat-account/what-is-the-demat-account-number-format/"
                      >What is the Demat Account Number Format?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="21"
                      href="/learning-center/demat-account/nsdl-demat-account-guide-for-beginners/"
                      >NSDL Demat Account - Login, Registration, Status, &amp;
                      How to Check</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="22"
                      href="/learning-center/demat-account/how-to-know-my-demat-account-number/"
                      >How to Know my Demat Account Number?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="23"
                      href="/learning-center/demat-account/how-to-open-a-joint-demat-account/"
                      >How to Open a Joint Demat Account?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="24"
                      href="/learning-center/demat-account/what-is-client-id-in-demat-account/"
                      >What Is Client Id In Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="25"
                      href="/learning-center/demat-account/dp-id-what-is-dp-id-in-the-demat-account/"
                      >DP ID: What Is Dp ID In The Demat Account?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="26"
                      href="/learning-center/demat-account/what-is-demand-deposit/"
                      >Demand Deposit - What It Is, Meaning, Example, &amp;
                      Account Types</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="27"
                      href="/learning-center/demat-account/how-to-choose-the-best-demat-account/"
                      >How to Choose the Best Demat Account?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="28"
                      href="/learning-center/demat-account/apply-for-3-in-1-online-trading-demat-bank-account/"
                      >Apply for 3 in 1 Online Trading, Demat &amp; Bank
                      Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="29"
                      href="/learning-center/demat-account/what-is-account-maintenance-charges-amc-in-demat-account/"
                      >What is Account Maintenance Charges (AMC) in Demat
                      Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="30"
                      href="/learning-center/demat-account/how-to-find-demat-account-number-from-pan/"
                      >How to Find Demat Account Number from PAN Card?</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="31"
                      href="/learning-center/demat-account/know-the-disadvantages-of-having-a-demat-account/"
                      >Know The Disadvantages of Having a Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="32"
                      href="/learning-center/demat-account/all-you-need-to-know-about-cdsl-demat-account-statement/"
                      >All You Need to Know About CDSL Demat Account
                      Statement</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="33"
                      href="/learning-center/demat-account/what-is-a-basic-service-demat-account/"
                      >What is a Basic Service Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="34"
                      href="/learning-center/demat-account/the-basics-of-stock-market-analysis/"
                      >The Basics of Stock Market Analysis</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="35"
                      href="/learning-center/demat-account/dematerialisation/"
                      >What is Dematerialisation of Shares - Meaning, Process
                      &amp; Advantages</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="36"
                      href="/learning-center/demat-account/documents-required-for-a-demat-account/"
                      >Documents required for demat account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="37"
                      href="/learning-center/demat-account/demat-and-trading-account-charges/"
                      >Demat Account Charges In India 2023</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="38"
                      href="/learning-center/demat-account/difference-between-demat-account-and-trading-account/"
                      >Demat Account Vs Trading Account - Differences, What It
                      Is, &amp; Which is Better</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="39"
                      href="/learning-center/demat-account/account-opening-form-for-a-demat-account/"
                      >Account opening form for a demat account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="40"
                      href="/learning-center/demat-account/eligibility-criteria-to-open-a-demat-account/"
                      >Eligibility criteria to open a demat account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="41"
                      href="/learning-center/demat-account/how-to-invest-using-demat-account/"
                      >How to Invest using Demat Account</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="42"
                      href="/learning-center/demat-account/types-of-demat-accounts/"
                      >Types of demat accounts</a
                    >
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="43"
                      href="/learning-center/demat-account/things-to-keep-in-mind-before-opening-a-demat-account/"
                      >Things to keep in mind before opening a demat account</a
                    >
                  </h2>
                </li>
                <!-- <div id="showall-posts" @click="openView">Show All</div> -->
                <!-- <div class="scroll-down" id="scroll-d">
                <img
                  alt="Scroll Down"
                  src="https://upstox.com/app/themes/upstox/dist/img/learning_center/scroll.png"
                />
              </div> -->
              </ul>
              <ul class="lc-category-page-wrapper hidden-xs hidden-sm">
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="1"
                      href="/learning-center/demat-account/best-demat-account-for-beginners-in-india/"
                    >
                      Best Demat Account in India for Beginners
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="2"
                      href="/learning-center/demat-account/how-to-download-demat-holdings-statement/"
                    >
                      How to Download Demat Holdings Statement
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="3"
                      href="/learning-center/demat-account/what-is-a-brokerage-account/"
                    >
                      What Is a Brokerage Account?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="4"
                      href="/learning-center/demat-account/demat-account-opening-procedure/"
                    >
                      Demat Account Opening Procedure &amp; Steps for Beginners
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="5"
                      href="/learning-center/demat-account/what-is-the-minimum-amount-required-for-opening-a-demat-account/"
                    >
                      What Is The Minimum Amount Required For Opening A Demat
                      Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="6"
                      href="/learning-center/demat-account/can-a-demat-account-be-opened-without-a-pan-card/"
                    >
                      Can a Demat Account Be Opened Without a PAN Card?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="7"
                      href="/learning-center/demat-account/how-to-buy-sell-shares-in-demat-account/"
                    >
                      How to Buy &amp; Sell Shares in Demat Account?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="8"
                      href="/learning-center/demat-account/what-is-ledger-balance-in-demat-account/"
                    >
                      What Is Ledger Balance In Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a
                      id="9"
                      href="/learning-center/demat-account/is-demat-account-safe/"
                    >
                      Is Demat Account Safe?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="10"
                      href="/learning-center/demat-account/when-bonus-shares-are-credited-in-demat-account/"
                    >
                      When Bonus Shares Are Credited In Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="11"
                      href="/learning-center/demat-account/how-do-i-add-a-nominee-to-my-demat-account/"
                    >
                      How Do I Add A Nominee To My Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="12"
                      href="/learning-center/demat-account/how-to-convert-physical-shares-to-demat/"
                    >
                      How to Convert Physical Shares to Demat
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="13"
                      href="/learning-center/demat-account/how-to-use-a-demat-account-online-in-india/"
                    >
                      How To Use A Demat Account Online In India
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="14"
                      href="/learning-center/demat-account/how-to-close-a-demat-account/"
                    >
                      How to Close Your Demat Account Online
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="15"
                      href="/learning-center/demat-account/how-to-open-a-demat-account/"
                    >
                      How to Open a Demat Account ?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="16"
                      href="/learning-center/demat-account/what-is-a-special-memorandum-account-sma/"
                    >
                      What Is a Special Memorandum Account (SMA)?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="17"
                      href="/learning-center/demat-account/how-to-check-demat-account-balance/"
                    >
                      How to Check Demat Account Balance
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="18"
                      href="/learning-center/demat-account/benefits-and-features-of-a-demat-account-understanding-the-advantages/"
                    >
                      Benefits And Features of a Demat Account - Understanding
                      the Advantages
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="19"
                      href="/learning-center/demat-account/understanding-a-demat-account-statement/"
                    >
                      Demat Account Holding Statement &amp; How to Get Demat
                      Statement
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="20"
                      href="/learning-center/demat-account/what-is-the-demat-account-number-format/"
                    >
                      What is the Demat Account Number Format?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="21"
                      href="/learning-center/demat-account/nsdl-demat-account-guide-for-beginners/"
                    >
                      NSDL Demat Account - Login, Registration, Status, &amp;
                      How to Check
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="22"
                      href="/learning-center/demat-account/how-to-know-my-demat-account-number/"
                    >
                      How to Know my Demat Account Number?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="23"
                      href="/learning-center/demat-account/how-to-open-a-joint-demat-account/"
                    >
                      How to Open a Joint Demat Account?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="24"
                      href="/learning-center/demat-account/what-is-client-id-in-demat-account/"
                    >
                      What Is Client Id In Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="25"
                      href="/learning-center/demat-account/dp-id-what-is-dp-id-in-the-demat-account/"
                    >
                      DP ID: What Is Dp ID In The Demat Account?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="26"
                      href="/learning-center/demat-account/what-is-demand-deposit/"
                    >
                      Demand Deposit - What It Is, Meaning, Example, &amp;
                      Account Types
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="27"
                      href="/learning-center/demat-account/how-to-choose-the-best-demat-account/"
                    >
                      How to Choose the Best Demat Account?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="28"
                      href="/learning-center/demat-account/apply-for-3-in-1-online-trading-demat-bank-account/"
                    >
                      Apply for 3 in 1 Online Trading, Demat &amp; Bank Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="29"
                      href="/learning-center/demat-account/what-is-account-maintenance-charges-amc-in-demat-account/"
                    >
                      What is Account Maintenance Charges (AMC) in Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="30"
                      href="/learning-center/demat-account/how-to-find-demat-account-number-from-pan/"
                    >
                      How to Find Demat Account Number from PAN Card?
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="31"
                      href="/learning-center/demat-account/know-the-disadvantages-of-having-a-demat-account/"
                    >
                      Know The Disadvantages of Having a Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="32"
                      href="/learning-center/demat-account/all-you-need-to-know-about-cdsl-demat-account-statement/"
                    >
                      All You Need to Know About CDSL Demat Account Statement
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="33"
                      href="/learning-center/demat-account/what-is-a-basic-service-demat-account/"
                    >
                      What is a Basic Service Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="34"
                      href="/learning-center/demat-account/the-basics-of-stock-market-analysis/"
                    >
                      The Basics of Stock Market Analysis
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="35"
                      href="/learning-center/demat-account/dematerialisation/"
                    >
                      What is Dematerialisation of Shares - Meaning, Process
                      &amp; Advantages
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="36"
                      href="/learning-center/demat-account/documents-required-for-a-demat-account/"
                    >
                      Documents required for demat account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="37"
                      href="/learning-center/demat-account/demat-and-trading-account-charges/"
                    >
                      Demat Account Charges In India 2023
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="38"
                      href="/learning-center/demat-account/difference-between-demat-account-and-trading-account/"
                    >
                      Demat Account Vs Trading Account - Differences, What It
                      Is, &amp; Which is Better
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="39"
                      href="/learning-center/demat-account/account-opening-form-for-a-demat-account/"
                    >
                      Account opening form for a demat account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="40"
                      href="/learning-center/demat-account/eligibility-criteria-to-open-a-demat-account/"
                    >
                      Eligibility criteria to open a demat account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="41"
                      href="/learning-center/demat-account/how-to-invest-using-demat-account/"
                    >
                      How to Invest using Demat Account
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="42"
                      href="/learning-center/demat-account/types-of-demat-accounts/"
                    >
                      Types of demat accounts
                    </a>
                  </h2>
                </li>
                <li class="LC-toc-list" :class="[view ? '' : 'hide']">
                  <h2>
                    <a
                      id="43"
                      href="/learning-center/demat-account/things-to-keep-in-mind-before-opening-a-demat-account/"
                    >
                      Things to keep in mind before opening a demat account
                    </a>
                  </h2>
                </li>
                <!-- <div id="showall-posts" @click="openView">Show All</div> -->
              </ul>
            </div>
          </div>
          <div class="lc-toc-container"></div>
        </div>
      </section>
      <div id="showall-article" class="showall-article hidden-md hidden-lg">
        Table of contents
      </div>
    </section>
    <exploremoreLcCat></exploremoreLcCat>
  </div>
</template>
<style scoped>
</style>
